<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
    custom-class="fifl-alert-like-dialog"
    :append-to-body="true"
    top="20px"
  >
    <div
      slot="title"
      class="dialog-header"
    >
      <h2>예약 차단 설정</h2>
      <span>
        예약 차단 일정을 사유와 함께 등록해주세요.<br>전체 회원에게 푸시
        알림으로 공지해드립니다.
      </span>
    </div>
    <el-form
      label-position="top"
      label-width="100px"
      :model="form"
      :rules="formValidateRules"
      style="padding-bottom: 0"
    >
      <el-row :gutter="15">
        <el-col :sm="16">
          <el-form-item label="">
            <el-date-picker
              class="responsive-visible desktop"
              v-model="targetDate"
              prefix-icon="none"
              type="date"
            />
            <input-date-mobile
              class="responsive-visible mobile"
              v-model="targetDate"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="8">
          <el-form-item label="">
            <el-checkbox
              style="width: 100%"
              v-model="isAllDay"
              label="하루종일"
              border
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="차단 시작 시간">
            <el-time-picker
              class="responsive-visible desktop"
              v-model="startTime"
              format="HH:mm"
              value-format="HH:mm"
              :disabled="isAllDay"
              placeholder="시작 시간"
            />
            <input-time-mobile
              class="responsive-visible mobile"
              v-model="startTime"
              :disabled="isAllDay"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="차단 종료 시간">
            <el-time-picker
              class="responsive-visible desktop"
              v-model="endTime"
              format="HH:mm"
              value-format="HH:mm"
              :disabled="isAllDay"
              :picker-options="endTimePickerOptions"
              placeholder="종료 시간"
            />
            <input-time-mobile
              class="responsive-visible mobile"
              :date="targetDate"
              :minimum-date="startDatetime"
              minimum-date-warning-message="시작 시간 이전 시간은 선택할 수 없습니다."
              v-model="endTime"
              :disabled="isAllDay"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :sm="24">
          <el-form-item
            label=""
            prop="memo"
          >
            <el-input
              v-model="form.memo"
              placeholder="차단 사유 입력 (20자 이내)"
              :maxlength="20"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        v-show="!data.id"
        class="white"
        @click="closeDialog"
        :loading="isBtnLoading"
      >
        취소
      </el-button>
      <el-button 
        v-show="data.id" 
        class="white"
        @click="deleteForm"
        :loading="isBtnLoading"
      >
        삭제
      </el-button>
      <el-button
        class="gray"
        :disabled="form.memo.length === 0"
        @click="saveForm"
        :loading="isBtnLoading"
      >
        확인
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import FormDialog from '@/components/AbstractComponents/FormDialog.vue';
import dateFns from 'date-fns';
import InputDateMobile from '@/components/InputDateMobile';
import InputTimeMobile from '@/components/InputTimeMobile';
import { setTimeOnDate } from '@/utils/date-helper';
import { fiflboxApi } from '@/utils/api';

export default {
  name: 'BookingBlockDialog',
  components: { InputTimeMobile, InputDateMobile },
  extends: FormDialog,
  props: ['data'],
  data() {
    return {
      targetDate: new Date(),
      		startTime: null,
      		endTime: null,
      isAllDay: false,
      isBtnLoading: false,
      form: {
        start: null,
        end: null,
        memo: '',
      },
      formValidateRules: {
        memo: [{ min: 1, message: '20자 이내로 입력해주세요.', trigger: 'change' }],
      },
    };
  },
  computed: {
    startDatetime() {
      return setTimeOnDate(this.targetDate, this.startTime);
    },
    endTimePickerOptions() {
      const rangeStart = this.startTime !== null ? this.startTime : '00:00';

      return {
        selectableRange: `${rangeStart}:00 - 23:59:59`,
      };
    },
  },
  watch: {
    data(value) {
      this.targetDate = value.start;

      if (value.id) {
        this.form = value;
        this.startTime = dateFns.format(value.start, 'HH:mm');
        this.endTime =  dateFns.format(value.end, 'HH:mm');
        this.isAllDay = dateFns.differenceInDays(value.end, value.start) === 1;
      }
    },
  },
  methods: {
    initFormData() {
      this.targetDate = null;
      this.startTime = null;
      this.endTime = null;
      this.isAllDay = false;

      this.form = {
        start: null,
        end: null,
        memo: '',
      };
    },
    calcFormTime() {
      if (this.isAllDay) {
        this.form.start = dateFns.startOfDay(this.targetDate);
        this.form.end = dateFns.addDays(this.form.start, 1);
        return true;
      }

      if(!this.startTime || !this.endTime) {
        return false;
      }

      if(dateFns.isAfter(this.startTime,this.endTime)){
        return false;
      }

      let day = dateFns.startOfDay(this.targetDate);
      this.form.start = setTimeOnDate(day, this.startTime);
      this.form.end = setTimeOnDate(day, this.endTime);

      return true;
    },
    async checkBookingExist({ start, end }) {
      try {
        let { data: bookings } = await fiflboxApi.v1.getBookings({
          status: [
            'BOOKED', 'PASS',
          ],
          dt_after: start,
          dt_before: end,
        });
        return bookings.length > 0;
      } catch (err) {}
    },
    /* deprecated code
		async checkCourseExist({ start, end }) {
			try {
				let dateString = dateFns.format(this.targetDate, 'YYYY-MM-DD');
				let { data: courses } = await fiflboxApi.v1.getChildCourses({
					date_after: dateString,
					date_before: dateString,
				})

				if (!courses[dateString]) {
					return false;
				}

				let coursesInRange = courses[dateString].filter(course => {
					return dateFns.isWithinRange(course.dt, start, end);
				});

				return coursesInRange.length > 0;
			} catch (err) {}
		},*/
    async saveForm() {
      this.isBtnLoading = true;
      let timeResult = this.calcFormTime();

      if (!timeResult) {
        this.isBtnLoading = false;
        return this.$alert(
          '예약 차단 시간을 정확히 설정해주세요.',
          '예약 차단 불가',
          {
            confirmButtonText: '확인',
            showClose: false,
            customClass: 'fifl-message-box',
            confirmButtonClass: 'gray',
          },
        );
      }

      let isBookingExist = await this.checkBookingExist(this.form);
      /* deprecated code
			let isCourseExist = await this.checkCourseExist(this.form);
			if (isBookingExist|| isCourseExist)
			*/
      if (isBookingExist) {
        this.closeDialog();
        this.isBtnLoading = false;
        return this.$alert(
          '선택하신 일정에 이미 등록된 예약 내역이 있습니다. 모든 예약 내역을 먼저 취소한 후 예약 차단을 진행해 주시길 바랍니다.',
          '예약 차단 불가',
          {
            confirmButtonText: '확인',
            cancelButtonText: '취소',
            showClose: false,
            customClass: 'fifl-message-box',
            confirmButtonClass: 'gray',
            cancelButtonClass: 'white',
          },
        );
      }
			
      if (this.form.id) {
        await fiflboxApi.v1.putBookingBlockings(this.form.id, this.form);
      } else {
        await fiflboxApi.v1.postBookingBlockings(this.form);
      }
      this.closeDialog();
      await this.$store.dispatch('syncBlocking', this.form.start);
      this.isBtnLoading = false;
      this.$message('예약이 차단됐습니다.');
    },
    async deleteForm() {
      this.isBtnLoading = true;
      await fiflboxApi.v1.deleteBookingBlockings(this.form.id, this.form);
      this.closeDialog();
      await this.$store.dispatch('syncBlocking', this.form.start);
      this.isBtnLoading = false;
      this.$message('예약이 차단이 취소됐습니다.');
    },
  },
};
</script>

<style lang="scss">
.fifl-alert-like-dialog {
  width: 425px;
  border-radius: 10px;

  .dialog-header {
    color: #4a4a4a;

    span {
      line-height: 19px;
      font-size: 13px;
      font-weight: 300;
      letter-spacing: -0.6px;
      margin-bottom: 5px;
    }

    h2 {
      margin: 0;
      line-height: 24px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: -0.5px;
    }
  }

  .el-dialog__header {
    padding: 20px 20px 0;
  }

  .el-dialog__body {
    padding: 0px 15px;
  }

  .el-dialog__footer {
    padding: 20px;
    padding-top: 0px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-checkbox {
    width: 105px;
    height: 50px;
    border-radius: 6px;
    display: flex;
    .el-checkbox__input {
      margin: auto 0;
      width: 14px;
      height: 14px;
    }

    .el-checkbox__label {
      margin: auto 0;
      line-height: 20px;
      font-size: 14px;
      font-weight: normal;
    }
  }

  @media screen and (max-width: 768px) {
    width: calc(100% - 20px);
  }
}
</style>
